import { SET_PROGRAMS, SET_PROGRAM, SET_SUGGESTED_PROGRAMS, SET_PROGRAM_WORKOUTS } from "./types";

const initialState = {
    programs: [],
    suggestedPrograms: [],
    program: null,

    workouts: {

    },
};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_PROGRAMS:
            return {
                ...state,
                programs: action.data
            }

        case SET_SUGGESTED_PROGRAMS:
            return {
                ...state,
                suggestedPrograms: action.data
            }

        case SET_PROGRAM:
            return {
                ...state,
                program: action.data
            }

        case SET_PROGRAM_WORKOUTS:
            return {
                ...state,
                workouts: {
                    ...state.workouts,
                    [action?.data?.key]: [...action?.data?.list]
                }
            }

        default:
            return state;
    }
}